import React, { useState } from 'react'
import classes from './navbar.module.css'
import { Link, NavLink } from 'react-router-dom'
import { Data } from '../../db/db'

export default function Navbar() {
    const [sideBar, setSideBar] = useState(false)
    const [showFlooring, setShowFlooring] = useState(false)
    const [showRevestimiento, setShowRevestimiento] = useState(false)
    const [showInterior, setShowInterior] = useState(false)
    const [showExterior, setShowExterior] = useState(false)
    const [showSmartHome, setShowSmartHome] = useState(false)
    const [showOffice, setShowOffice] = useState(false)
    const db = Data()

    const handleSideBar = () => setSideBar(!sideBar)

    // Detecta mobile (puedes mejorar esto con un hook o media query)
    const isMobile = window.innerWidth < 900

    if (!isMobile) {
        return (
            <nav>
                <div className={classes.navWidth}>
                    <div onClick={(sideBar) => sideBar ? { handleSideBar } : ''} className={sideBar ? `${classes.container} ${classes.cActive}` : `${classes.container}`}>
                        <div>
                            <Link to='/'>
                                <img className={classes.logo} src="/img/logo-blanco.png" alt="Logo Yuka" />
                            </Link>
                        </div>
                        <div>
                            <div onClick={handleSideBar} className={classes.contIcon}>
                                <div className={sideBar ? `${classes.topBar} ${classes.topBarActive}` : `${classes.topBar}`}></div>
                                <div className={sideBar ? `${classes.bottomBar} ${classes.bottomBarActive}` : `${classes.bottomBar}`}></div>
                            </div>
                        </div>
                    </div>
                    <div onClick={handleSideBar} className={sideBar ? `${classes.links} ${classes.active}` : `${classes.links}`}>
                        <ul>
                            {/* Flooring con submenú */}
                            <li
                                style={{ position: 'relative' }}
                                onMouseEnter={() => setShowFlooring(true)}
                                onMouseLeave={() => setShowFlooring(false)}
                            >
                                <span
                                    className={classes.link}
                                    style={{ cursor: 'default', fontSize: '1em', userSelect: 'none' }}
                                >
                                    FLOORING
                                </span>
                                {showFlooring && (
                                    <ul className={classes.submenuVertical}>
                                        <li>
                                            <NavLink className={classes.link} to="/selectFlooring">SELECT FLOORING</NavLink>
                                        </li>
                                        <li>
                                            <NavLink className={classes.link} to="/classicFlooring">CLASSIC FLOORING</NavLink>
                                        </li>
                                    </ul>
                                )}
                            </li>
                            {/* Revestimiento de pared con submenú */}
                            <li
                                style={{ position: 'relative' }}
                                onMouseEnter={() => setShowRevestimiento(true)}
                                onMouseLeave={() => { setShowRevestimiento(false); setShowInterior(false); setShowExterior(false); }}
                            >
                                <span
                                    className={classes.link}
                                    style={{ cursor: 'default', fontSize: '1em', userSelect: 'none' }}
                                >
                                    REVESTIMIENTO DE PARED
                                </span>
                                {showRevestimiento && (
                                    <ul className={classes.submenuVertical}>
                                        <li
                                            onMouseEnter={() => setShowInterior(true)}
                                            onMouseLeave={() => setShowInterior(false)}
                                            style={{ position: 'relative' }}
                                        >
                                            <span className={classes.link} style={{ cursor: 'default', userSelect: 'none' }}>INTERIOR</span>
                                            {showInterior && (
                                                <ul className={classes.submenuHorizontal}>
                                                    <li>
                                                        <NavLink className={classes.link} to="/woodPanels">WOOD PANELS</NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink className={classes.link} to="/natural-wall">NATURAL WALL</NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink className={classes.link} to="/giantWallPanels">GIANT WALLPANELS</NavLink>
                                                    </li>
                                                </ul>
                                            )}
                                        </li>
                                        <li
                                            onMouseEnter={() => setShowExterior(true)}
                                            onMouseLeave={() => setShowExterior(false)}
                                            style={{ position: 'relative' }}
                                        >
                                            <span className={classes.link} style={{ cursor: 'default', userSelect: 'none' }}>EXTERIOR</span>
                                            {showExterior && (
                                                <ul className={classes.submenuHorizontal}>
                                                    <li>
                                                        <NavLink className={classes.link} to="/sidingdeexterior">SIDING WPC EXTERIOR</NavLink>
                                                    </li>
                                                </ul>
                                            )}
                                        </li>
                                    </ul>
                                )}
                            </li>
                            {/* Zócalos de PVC hardcodeado */}
                            <li>
                                <NavLink
                                    className={classes.link}
                                    to="/zocalosPvc"
                                >
                                    ZÓCALOS DE PVC
                                </NavLink>
                            </li>
                            {/* Smart Home con submenú */}
                            <li
                                style={{ position: 'relative' }}
                                onMouseEnter={() => setShowSmartHome(true)}
                                onMouseLeave={() => setShowSmartHome(false)}
                            >
                                <span
                                    className={classes.link}
                                    style={{ cursor: 'default', fontSize: '1em', userSelect: 'none' }}
                                >
                                    SMART HOME
                                </span>
                                {showSmartHome && (
                                    <ul className={classes.submenuVertical}>
                                        <li>
                                            <NavLink className={classes.link} to="/bachas-cocina-smart">BACHAS</NavLink>
                                        </li>
                                        <li>
                                            <NavLink className={classes.link} to="/duchas-smart">DUCHAS</NavLink>
                                        </li>
                                    </ul>
                                )}
                            </li>
                            {/* Oficina con submenú */}
                            <li
                                style={{ position: 'relative' }}
                                onMouseEnter={() => setShowOffice(true)}
                                onMouseLeave={() => setShowOffice(false)}
                            >
                                <span
                                    className={classes.link}
                                    style={{ cursor: 'default', fontSize: '1em', userSelect: 'none' }}
                                >
                                    OFFICE
                                </span>
                                {showOffice && (
                                    <ul className={classes.submenuVertical}>
                                        <li>
                                            <NavLink className={classes.link} to="/sillas-ergonomicas">SILLAS ERGONÓMICAS</NavLink>
                                        </li>
                                    </ul>
                                )}
                            </li>
                            {/* Menú original, excluyendo los de flooring */}
                            {
                                db
                                .filter(l =>
                                    l.categoria !== 'select flooring' &&
                                    l.categoria !== 'classic flooring' &&
                                    l.categoria !== 'wood panels' &&
                                    l.categoria !== 'giant wall panels' &&
                                    l.categoria !== 'siding wpc exterior' &&
                                    l.categoria !== 'zocalos de pvc' &&
                                    l.categoria !== 'natural wall' &&
                                    l.categoria !== 'bachas de cocina smart sink' &&
                                    l.categoria !== 'duchas smart' &&
                                    l.categoria !== 'sillas ergonómicas'
                                )
                                .map(l =>
                                    <li key={l.id}>
                                        <NavLink className={({ isActive }) => isActive ? `${classes.linkActive} ` : `${classes.link}`} to={`/${l.link}`}>{l.categoria}</NavLink>
                                    </li>
                                )
                            }
                        </ul>
                    </div>
                </div>
            </nav>
        )
    }

    // Menú mobile
    return (
        <nav className={classes.mobileNav}>
            <div className={classes.mobileHeader}>
                <Link to='/'>
                    <img className={classes.logo} src="/img/logo-blanco.png" alt="Logo Yuka" />
                </Link>
                <button className={classes.mobileMenuBtn} onClick={() => setSideBar(!sideBar)}>
                    ☰
                </button>
            </div>
            {sideBar && (
                <>
                    <div
                        className={classes.mobileBackdrop}
                        onClick={() => setSideBar(false)}
                    />
                    <div className={classes.mobileMenu}>
                        {/* Botón logo arriba del menú mobile */}
                        <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
                            <Link to="/" onClick={() => setSideBar(false)}>
                                <img
                                    src="/img/logo-blanco.png"
                                    alt="Logo Yuka"
                                    style={{ height: 40, objectFit: 'contain' }}
                                />
                            </Link>
                        </div>
                        <ul>
                            {/* FLOORING */}
                            <li>
                                <button className={classes.mobileMenuItem} onClick={() => setShowFlooring(!showFlooring)}>
                                    FLOORING
                                </button>
                                {showFlooring && (
                                    <ul className={classes.mobileSubmenu}>
                                        <li>
                                            <NavLink className={classes.mobileMenuLink} to="/selectFlooring" onClick={() => setSideBar(false)}>SELECT FLOORING</NavLink>
                                        </li>
                                        <li>
                                            <NavLink className={classes.mobileMenuLink} to="/classicFlooring" onClick={() => setSideBar(false)}>CLASSIC FLOORING</NavLink>
                                        </li>
                                    </ul>
                                )}
                            </li>
                            {/* REVESTIMIENTO DE PARED */}
                            <li>
                                <button className={classes.mobileMenuItem} onClick={() => setShowRevestimiento(!showRevestimiento)}>
                                    REVESTIMIENTO DE PARED
                                </button>
                                {showRevestimiento && (
                                    <ul className={classes.mobileSubmenu}>
                                        <li>
                                            <button className={classes.mobileMenuItem} onClick={() => setShowInterior(!showInterior)}>
                                                INTERIOR
                                            </button>
                                            {showInterior && (
                                                <ul className={classes.mobileSubmenu}>
                                                    <li>
                                                        <NavLink className={classes.mobileMenuLink} to="/woodPanels" onClick={() => setSideBar(false)}>WOOD PANELS</NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink className={classes.mobileMenuLink} to="/giantWallPanels" onClick={() => setSideBar(false)}>GIANT WALLPANELS</NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink className={classes.mobileMenuLink} to="/natural-wall" onClick={() => setSideBar(false)}>NATURAL WALL</NavLink>
                                                    </li>
                                                </ul>
                                            )}
                                        </li>
                                        <li>
                                            <button className={classes.mobileMenuItem} onClick={() => setShowExterior(!showExterior)}>
                                                EXTERIOR
                                            </button>
                                            {showExterior && (
                                                <ul className={classes.mobileSubmenu}>
                                                    <li>
                                                        <NavLink className={classes.mobileMenuLink} to="/sidingdeexterior" onClick={() => setSideBar(false)}>SIDING WPC EXTERIOR</NavLink>
                                                    </li>
                                                </ul>
                                            )}
                                        </li>
                                    </ul>
                                )}
                            </li>
                            {/* ZÓCALOS DE PVC */}
                            <li>
                                <NavLink className={classes.mobileMenuLink} to="/zocalosPvc" onClick={() => setSideBar(false)}>
                                    ZÓCALOS DE PVC
                                </NavLink>
                            </li>
                            {/* SMART HOME */}
                            <li>
                                <button className={classes.mobileMenuItem} onClick={() => setShowSmartHome(!showSmartHome)}>
                                    SMART HOME
                                </button>
                                {showSmartHome && (
                                    <ul className={classes.mobileSubmenu}>
                                        <li>
                                            <NavLink className={classes.mobileMenuLink} to="/bachas-cocina-smart" onClick={() => setSideBar(false)}>BACHAS</NavLink>
                                        </li>
                                        <li>
                                            <NavLink className={classes.mobileMenuLink} to="/duchas-smart" onClick={() => setSideBar(false)}>DUCHAS</NavLink>
                                        </li>
                                    </ul>
                                )}
                            </li>
                            {/* OFFICE */}
                            <li>
                                <button className={classes.mobileMenuItem} onClick={() => setShowOffice(!showOffice)}>
                                    OFFICE
                                </button>
                                {showOffice && (
                                    <ul className={classes.mobileSubmenu}>
                                        <li>
                                            <NavLink className={classes.mobileMenuLink} to="/sillas-ergonomicas" onClick={() => setSideBar(false)}>SILLAS ERGONÓMICAS</NavLink>
                                        </li>
                                    </ul>
                                )}
                            </li>
                            {/* Otros items */}
                            {
                                db
                                    .filter(l =>
                                        l.categoria !== 'select flooring' &&
                                        l.categoria !== 'classic flooring' &&
                                        l.categoria !== 'wood panels' &&
                                        l.categoria !== 'giant wall panels' &&
                                        l.categoria !== 'siding wpc exterior' &&
                                        l.categoria !== 'zocalos de pvc' &&
                                        l.categoria !== 'natural wall' &&
                                        l.categoria !== 'bachas de cocina smart sink' &&
                                        l.categoria !== 'duchas smart' &&
                                        l.categoria !== 'sillas ergonómicas'
                                    )
                                    .map(l =>
                                        <li key={l.id}>
                                            <NavLink className={classes.mobileMenuLink} to={`/${l.link}`} onClick={() => setSideBar(false)}>{l.categoria}</NavLink>
                                        </li>
                                    )
                            }
                        </ul>
                    </div>
                </>
            )}
        </nav>
    )
}